// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
interface Props {
  onClick?: (event) => void;
  size?: number;
  strokeColor?: string;
}
export const IconChevronUp: React.FC<Props> = ({
  onClick,
  size = 16,
  strokeColor = '#ffffff',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M4 10L7.85858 6.14142C7.93668 6.06332 8.06332 6.06332 8.14142 6.14142L12 10"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
